export const Currencies = "/assets/svg/currencies.svg";
export const Global = "/assets/svg/global.svg";
export const TrustPilotStar = "/assets/svg/star-trustpilot.svg";
export const FullManagement = "/assets/svg/FullManagement.svg";
export const ClearPricing = "/assets/svg/ClearPricing.svg";
export const LowerCosts = "/assets/svg/LowerCosts.svg";
export const Frame = "/assets/svg/Frame.svg";
export const Commitment = "/assets/svg/Commitment.svg";
export const Efficiency = "/assets/svg/Efficiency.svg";
export const Security = "/assets/svg/Security.svg";
export const Time_1 = "/assets/svg/Time_1.svg";
export const Alt_1 = "/assets/svg/Alt_1.svg";
export const NopaperImg = "/assets/svg/paperwork.svg";
export const InsatntSetupImg = "/assets/svg/insatntsetup.svg";
export const FeeImg = "/assets/svg/fee.svg";
export const ChevronDownIcon = '/assets/svg/chervon-down.svg';
export const GlobeIcon = '/assets/svg/globe.svg';
export const LoginIcon = '/assets/svg/login.svg';
export const menuHeader = '/assets/svg/menu-header.svg';
export const BussinessIcon = '/assets/svg/bussiness-icon.svg';
export const FreelanceIcon = '/assets/svg/freelancer-icon.svg';
export const Swedish = '/assets/svg/swedish.svg';
export const English = '/assets/svg/english.svg';
export const CloseIcon = '/assets/svg/close-icon.svg';
export const DoneIcon = '/assets/svg/done-icon.svg';
export const Trophy = '/assets/svg/trophy.svg';
export const Lock = '/assets/svg/lock.svg';
export const Timer = '/assets/svg/timer.svg';
export const Easy = '/assets/svg/easy.svg';
export const ChevronUpIcon = '/assets/svg/arrowup.svg';
export const arrowUp = '/assets/svg/arrowup.svg'
export const arrowDown = '/assets/svg/arrow-down.svg';
export const Avatar = '/assets/svg/Avatar.svg';
export const Star = '/assets/svg/star.svg';
export const Revolt = '/assets/svg/Revolt.svg';
export const Microsoft = '/assets/svg/microsoft-logo-svgrepo-com.svg';
export const POSLOGO = '/assets/svg/pos_logo.svg';
export const Euro = '/assets/svg/Euro_Accident_Logo_2016.svg';
export const BankId = '/assets/svg/bankid-vector-logo.svg';
export const Tryggg = '/assets/svg/try_ggg.svg';
export const dollar = '/assets/svg/dollar.svg';
export const externalLink = '/assets/svg/external-link.svg';
export const trygggcolor = '/assets/svg/trygg-color.svg';
export const bankidcolor = '/assets/svg/bankid-vector-logo-color.svg';
export const euroaccidentcolor = '/assets/svg/Euro_Accident_Logo_2016-color.svg';
export const microsoftcolor = '/assets/svg/microsoft-logo-svgrepo-com-color.svg';
export const sppcolorlogo = '/assets/svg/spp-color-logo.svg';
export const RevoltGray = '/assets/svg/Revolt-gray.svg';
export const down = '/assets/svg/down.svg';
export const sppcolorimage = '/assets/svg/spp-color-logo.svg';
export const menuImg = '/assets/svg/dropdown-menu.svg';
export const Sweden = '/assets/svg/Sweden-flag.svg';
export const ChevronArrowUpIcon = '/assets/svg/up.svg';
export const MicrosoftGray = '/assets/svg/microsoft-gray.svg';
export const EuroGray = '/assets/svg/euro-accident-gray.svg'
export const AzureGray = '/assets/svg/azure-devops-gray.svg'
export const BankIdGray = '/assets/svg/bankid-gray.svg'
export const SPPGray = '/assets/svg/spp-logo-gray.svg';
export const TrygggGray = '/assets/svg/tryggg-gray.svg';
export const rightArrow = '/assets/svg/right.svg';
export const rightArrowBlack = '/assets/svg/right-dark.svg';
export const Plus = '/assets/svg/plus.svg';
export const Tooltip = '/assets/svg/tooltip.svg';
export const Calendar = '/assets/svg/calendar.svg';
export const GreyTimer = '/assets/svg/grey-timer.svg';
export const GreyRightArrow = '/assets/svg/grey-right.svg';
export const HollowStar = '/assets/svg/hollow-star.svg';
export const RightArrow = '/assets/svg/arrow-right.svg';
export const Share = '/assets/svg/share.svg';
export const LeftArrow = '/assets/svg/left-arrow.svg';
export const certificate = "/assets/svg/certificate.svg";
export const graphArrow = "/assets/svg/graph-arrow.svg";
export const CircleTick = "/assets/svg/circle-tick.svg";
export const Feather = '/assets/svg/feather.svg';
export const Gift = '/assets/svg/gift.svg';
export const Like = '/assets/svg/like.svg';
export const Coins = '/assets/svg/coins.svg';
export const NeutralEmoji = '/assets/svg/neutral-emoji.svg';
export const Chat = '/assets/svg/chat.svg';
export const Writing = '/assets/svg/writing.svg';
export const Development = '/assets/svg/development.svg';
export const Editing = '/assets/svg/editing.svg';
export const Marketing = '/assets/svg/marketing.svg';
export const Consultant = '/assets/svg/consultant.svg';
export const Translation = '/assets/svg/translate.svg';
export const Bullseye = '/assets/svg/bullseye.svg';
export const happyIcon  = '/assets/svg/happy-emoji.svg';
export const mindMapIcon  = '/assets/svg/share-icon.svg';
export const cameraIcon  = '/assets/svg/camera-icon.svg';
export const lightningIcon  = '/assets/svg/lightning.svg';
export const photoIcon  = '/assets/svg/photo-icon.svg';
export const coinsIcon = '/assets/svg/banking-and-finance.svg'
export const FreelancerIcon = '/assets/svg/freelancer-user-svg.svg'
export const BusinessIcon = '/assets/svg/bussiness-group-svg.svg'
export const GoogleIcon = '/assets/svg/google-logo.svg';
export const LinkedinIcon = '/assets/svg/linkedin-logo.svg';
export const FacebookIcon = '/assets/svg/facebook-logo.svg';
export const InvozioLogo = '/assets/svg/invozio-logo.svg'; 
export const SPPLogowhite = '/assets/svg/spp-white-logo.svg';
export const RevoltLogowhite = 'assets/svg/Revolt-white-logo.svg';
export const MicrosoftLogowhite = 'assets/svg/microsoft-svg.svg';
export const EuroAccidentLogowhite = 'assets/svg/euro-accident-white.svg';
export const BankIdLogowhite = '/assets/svg/bank-id-white-logo.svg';
export const TrygggLogowhite = '/assets/svg/tryggg-white.svg';
export const ShieldIcon = '/assets/svg/shield.svg'
export const Softwareqr = '/assets/svg/software-qr-code.svg'
export const externalLinkBlack = '/assets/svg/external-link-black.svg'
export const LockSvg = '/assets/svg/svg-lock-icon.svg'
export const ReloadIcon = '/assets/svg/reload-icon.svg'